import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import globalWindow from 'global/window';
export const useKeyboardShortcuts = (keys: string[], callback: (a: KeyboardEvent) => void, type = 'keydown') => {
  // implement the callback ref pattern
  const callbackRef = useRef(callback);
  const timerRef = useRef(null);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  // handle what happens on key press
  const handleKeyChange = useCallback(event => {
    // Check if user is typing in an input field, textarea, or contenteditable element
    const target = (event.target as HTMLElement);
    const isEditableElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable || target.contentEditable === 'true';

    // Skip hotkey execution if user is typing in an editable element
    if (isEditableElement) {
      return;
    }
    if (type === 'longpress' && keys.some(key => event.key === key)) {
      if (event.type === 'keydown') {
        if (timerRef.current === null)
          // @ts-expect-error missing null check
          timerRef.current = setTimeout(() => {
            callbackRef.current(event);
            timerRef.current = null;
          }, 800);
      }
      if (event.type === 'keyup') {
        callbackRef.current(event);
        // @ts-expect-error missing null check
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    } else {
      // check if one of the key is part of the ones we want
      if (event.type === type && keys.some(key => event.key === key)) {
        callbackRef.current(event);
      }
    }
  }, [keys, type]);
  useEffect(() => {
    // target is either the provided node or the document

    // attach the event listener
    if (type === 'longpress') {
      globalWindow.addEventListener('visibilitychange', event => {
        callbackRef.current(event);
      });
      globalWindow.addEventListener('keyup', handleKeyChange);
      globalWindow.addEventListener('keydown', handleKeyChange);
    } else {
      globalWindow.addEventListener(type, handleKeyChange);
    }

    // remove the event listener
    return () => {
      if (type === 'longpress') {
        globalWindow.removeEventListener('keyup', handleKeyChange);
        globalWindow.removeEventListener('keydown', handleKeyChange);
        globalWindow.removeEventListener('visibilitychange', handleKeyChange);
      } else {
        globalWindow.removeEventListener(type, handleKeyChange);
      }
    };
  }, [handleKeyChange, type]);
};